<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          v-if="eduInfo.eduId==135"
          type="primary"
          plain
          size="mini"
          icon="el-icon-circle-plus-outline"
          @click="addClick()"
        >
          新增
        </el-button>
        <!-- <el-button
          type="danger"
          plain
          size="mini"
          icon="el-icon-circle-close"
          @click="delClick"
          :disabled="ids.length == 0 ? true : false"
          >删除</el-button
        > -->
        
        
      </div>
      <!-- <div class="search_box">
        <el-input
          v-model.trim="requestData.lectureUserName"
          size="mini"
          clearable
          placeholder="请输入会议名称"
        ></el-input>
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchData"
          >搜索</el-button
        >
      </div> -->
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          
          <el-table-column
            prop="cloudMeetingId"
            label="会议编号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="cloudMeetingName"
            label="会议名称"
            align="center"
          >
          <template v-slot='scope'>
            <span class="cloudTitle">{{ scope.row.cloudMeetingName  }}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="cloudMeetingContent"
             show-overflow-tooltip
            label="内容"
            align="center"
          >
          <template v-slot='scope'      >
            <span class="cloudContent">{{ scope.row.cloudMeetingContent  }}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="cloudMeetingCover"
            label="封面"
            align="center"
          >
          <template v-slot='scope'>
            <el-image  style="height: 80px;width: 130px;"  :src="$store.state.config.fileUrl+scope.row.cloudMeetingCover"></el-image>
            <!-- {{scope.row.lectureClass}}小时 -->
            </template>
          </el-table-column>
          <el-table-column
            prop="cloudMeetingStartTime"
            label="开始时间"
            align="center"
          >
          <template v-slot='scope'>
         {{timeFormate(scope.row.cloudMeetingStartTime*1000)   }}
            <!-- {{scope.row.lectureClass}}小时 -->
            </template>
        </el-table-column>
        <el-table-column
            prop="cloudMeetingStartTime"
            label="结束时间"
            align="center"
          >
          <template v-slot='scope'>
        {{timeFormate( scope.row.cloudMeetingEndTime*1000)  }}
            <!-- {{scope.row.lectureClass}}小时 -->
            </template>
        </el-table-column>
        <el-table-column
            prop="cloudMeetingStatus"
            label="状态"
            align="center"
          >
          <template v-slot='scope'>
                <el-tag v-if="scope.row.cloudMeetingStatus==0">未开始</el-tag>
                <el-tag type="success" v-if="scope.row.cloudMeetingStatus==1">进行中</el-tag>

                <el-tag type="danger" v-if="scope.row.cloudMeetingStatus==2">已结束</el-tag>

          </template>      
          </el-table-column>
          <el-table-column label="操作" align="center" width="300">
            <!-- <template v-slot="scope">
              <el-link
                type="primary"
                @click="editClick(scope.row)"
                :underline="false"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                type="primary"
                @click="delClick(scope.row)"
                :underline="false"
                >删除</el-link
              >
            </template> -->
            <template v-slot="scope">
              
              <el-button
                v-if="scope.row.cloudMeetingStatus==0"
                type="primary"
                @click="editClick(scope.row)"
                :underline="false"
                >开启</el-button
              > 
               <el-button
                v-else-if="scope.row.cloudMeetingStatus==1"
                type="danger"
                @click="editClick(scope.row)"
                :underline="false"
                >结束</el-button
              > 
            
              <el-button
                    v-if="eduInfo.eduId==135"
                      size="small"
                      type="primary"
                      @click="showLog(scope.row)"
                      :underline="false"
                      >观看记录</el-button
              >
               <el-button
               v-if="scope.row.cloudMeetingStatus==2"
                @click="addMeeting(scope.row)"
                :underline="false"
                icon="el-icon-video-play"
                type="primary"
                size="small"
                >回放</el-button
              > 
           
              <el-button
              v-if="eduInfo.eduId==135"
              size="small"
                      type="danger"
                      @click="delClick(scope.row)"
                      :underline="false"
                      >删除</el-button
              >
             
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <add-or-edit
      :initialData="initialData"
      :drawerShow="drawerShow"
      :drawerType="drawerType"
      @handleClose="handleClose"
      @saveData="saveData"
    ></add-or-edit>
    <el-dialog   :visible.sync="listShow" :wrapperClosable="false"  :append-to-body="true" title="会议记录" width="70%">
        <List ref="list"></List>
    </el-dialog>
  </div>
</template>

<script>
import { Form } from 'element-ui';
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
import addOrEdit from "./components/addOrEdit.vue";
import List from "./components/list.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  name: "prelectionRecord",
  components: {
    addOrEdit,List
  },
  props: {},
  data() {
    //这里存放数据
    return {
      requestData: {
        pageNum: 1,
        pageSize: 20,
        cloudMeetingEdu:'',
      },
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),

      listParams:{
        cloudMeetingId:null,
        pageNum: 1,
        pageSize: 20,
      },
      tableData: [],
      total: 0,
      drawerShow: false,
      drawerType: "add",
      listShow:false,
      initialData: {
        
      }
    };
  },
  //监控data中的数据变化
  watch: {},
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    timeFormate(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? "0" + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      let date =
        new Date(timeStamp).getDate() < 10
          ? "0" + new Date(timeStamp).getDate()
          : new Date(timeStamp).getDate();
      let hh =
        new Date(timeStamp).getHours() < 10
          ? "0" + new Date(timeStamp).getHours()
          : new Date(timeStamp).getHours();
      let mm =
        new Date(timeStamp).getMinutes() < 10
          ? "0" + new Date(timeStamp).getMinutes()
          : new Date(timeStamp).getMinutes();
      let ss =
        new Date(timeStamp).getSeconds() < 10
          ? "0" + new Date(timeStamp).getSeconds()
          : new Date(timeStamp).getSeconds();
    
     return    year +"-" + month + "-" +  date +  " " +  " " +   hh +   ":" +   mm +  ":" +   ss;
    },
    searchData() {
      this.requestData.pageNum = 1;
      this.getList();
    },
    addMeeting(info){
      this.$router.push({path: '/meeting_online?info='+JSON.stringify(info) })

      // this.$confirm("确定要加入当前会议吗?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // }).then(async () => {
      //   let time = new Date().getTime()
      //   let res = await this.$Http.joinCloudMeeting({ 
      //     cloudMeetingRecordsMeetingId: info.cloudMeetingId,
      //     cloudMeetingRecordsSchoolId:this.requestData.schoolId,
      //     cloudMeetingRecordsUserId:this.$store.getters.getUserInfo.userId,
      //     cloudMeetingRecordsTime:(time/1000).toFixed(0)
      //    },true);
      //    if(res.code==200){
      //    }else {
      //   this.$message({
      //     type: "error",
      //     message: res.messsage
      //   });
      // }
      //   });
    },
    addClick() {
      this.drawerShow = true;
      this.drawerType = "add";
      this.initialData = {
        lectureUserName: "",
        lectureTeacherUnit: "",
        lectureBeau: "",
        lectureClass: "",
        lectureName: "",
        lectureContent: "",
        lectureImages: "",
        lectureFiles: "",
        organizationId: this.$store.getters.getUserInfo.schoolId,
        type:3
      };
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getList();
    },
    async getList() {
      let req = Object.assign({}, this.requestData);
      let  regionCode  = this.eduInfo.regionCode.substring(0, 4)
      if(regionCode =='4112'){
        req.cloudMeetingEdu=135
      }else{
        req.cloudMeetingEdu=this.eduInfo.eduId
      }
     
      let res = await this.$Http.cloudMeeting(req);
      if (res.code == 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total || 0;
      } else if (res.code == 101) {
        this.tableData = [];
        this.total = 0;
      } else {
        this.tableData = [];
        this.total = 0;
        this.$message({
          type: "error",
          message: "查询失败"
        });
      }
    },
    editClick(info) {
      let text= info.cloudMeetingStatus==1?'关闭':'开启'
      this.$confirm(`确定要${text}当前会议吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        this.closeInfo(info)
      });
    },
     async closeInfo(info) {
      // let form =new FormData()
      // form.append('cloudMeetingStatus',info.cloudMeetingStatus==1?2:1)
      // form.append('cloudMeetingId',info.cloudMeetingId)
      let data={
        cloudMeetingId:info.cloudMeetingId,
        cloudMeetingStatus:info.cloudMeetingStatus==1?2:1

      }
      let res = await this.$Http.editCloudMeeting( data,true );
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        this.getList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: "操作失败"
        });
      }
    },
    checkInfo(info){
      this.drawerShow = true;
      this.drawerType = "info";
      this.initialData = {
        lectureUserName: info.lectureUserName,
        lectureTeacherUnit: info.lectureTeacherUnit,
        lectureBeau: info.lectureBeau,
        lectureClass: info.lectureClass,
        lectureName: info.lectureName,
        lectureContent: info.lectureContent,
        lectureImages: info.lectureImages,
        lectureFiles: info.lectureFiles,
        lectureId: info.lectureId,
      };
    },
    delClick(info) {
      this.$confirm("此操作将永久删除此记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        this.delInfo(info.cloudMeetingId);
      });
    },
    async delInfo(ids) {
      let res = await this.$Http.delCloudMeeting({ cloudMeetingId: ids });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        this.getList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: "删除失败"
        });
      }
    },
    handleClose() {
      this.drawerShow = false;
    },
    saveData(info) {
      if (this.drawerType == "add") {
        this.addInfo(info);
      } else {
        this.editInfo(info);
      }
    },
    async addInfo(info) {
      let req = Object.assign({}, info);
      let res = await this.$Http.addCloudMeeting(req);
      if (res.code == 200) {
        this.drawerShow = false;
        this.getList();
      } else {
        this.$message({
          type: "error",
          message: "新增失败"
        });
      }
    },
    async editInfo(info) {
      let req = Object.assign({}, info);
      let res = await this.$Http.addCloudMeeting(req);
      if (res.code == 200) {
        this.drawerShow = false;
        this.getList();
      } else {
        this.$message({
          type: "error",
          message: "编辑失败"
        });
      }
    },
     // 导出数据
    async exportData() {
      let req = {
        organizationId: this.$store.getters.getUserInfo.schoolId,
        type:3
      };
      this.$Common.exportData(req, "exportLectureRecords", "授课记录", true);
    },
  async showLog(row){
      // listShow
          this.listParams.cloudMeetingId = row.cloudMeetingId
         let res = await this.$Http.CloudMeetingList(this.listParams)
         this.listShow=true
          if (res.code == 200) {
            this.$nextTick(()=>{
              this.$refs.list.init(row.cloudMeetingId)

            })
          } else if (res.code == 101) {
        
          } else {
           
            this.$message({
              type: "error",
              message: "查询失败"
            });
          }
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {
    // this.requestData.cloudMeetingEdu = this.eduInfo.eduId
    this.getList();
  },
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
  .cloudTitle{
      color: #000;
  }
  .cloudContent{
      color: #999;
      font-size: 12px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  }
</style>
